// makeAdmin.js - A utility script to make a user an admin
import { auth, db } from '../firebase';
import { doc, updateDoc, getDoc, setDoc } from 'firebase/firestore';

// This function makes the currently logged-in user an admin
export const makeCurrentUserAdmin = async () => {
  try {
    const user = auth.currentUser;
    
    if (!user) {
      console.error('No user is currently logged in');
      return { success: false, message: 'No user is currently logged in' };
    }
    
    const userDocRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      // Update existing user document
      await updateDoc(userDocRef, {
        isAdmin: true,
        adminGrantedAt: new Date(),
        email: user.email // Ensure email is set for future admin management
      });
    } else {
      // Create new user document with admin privileges
      await setDoc(userDocRef, {
        isAdmin: true,
        email: user.email,
        adminGrantedAt: new Date(),
        createdAt: new Date()
      });
    }
    
    return { 
      success: true, 
      message: `Admin privileges granted to ${user.email}` 
    };
  } catch (error) {
    console.error('Error making user admin:', error);
    return { 
      success: false, 
      message: 'Failed to grant admin privileges: ' + error.message 
    };
  }
};

// This function checks if the current user is an admin
export const checkAdminStatus = async () => {
  try {
    const user = auth.currentUser;
    
    if (!user) {
      return { isAdmin: false, message: 'No user is logged in' };
    }
    
    const userDocRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      const userData = userDoc.data();
      return { 
        isAdmin: userData.isAdmin === true,
        email: user.email
      };
    } else {
      return { isAdmin: false, message: 'User document not found' };
    }
  } catch (error) {
    console.error('Error checking admin status:', error);
    return { 
      isAdmin: false, 
      message: 'Error checking admin status: ' + error.message 
    };
  }
};